<template>
  <div>
    <div class="form-inline">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <div>
          <el-form-item label="SN号">
            <el-input
              size="small"
              v-model="formInline.SN"
              placeholder="请输入SN号"
              style="width: 120px"
            ></el-input>
          </el-form-item>
          <el-form-item label="设备名称">
            <el-input
              size="small"
              v-model="formInline.name"
              placeholder="请输入设备名称"
              style="width: 140px"
            ></el-input>
          </el-form-item>
          <el-form-item label="品牌型号">
            <el-cascader
              v-model="formInline.brandName"
              size="small"
              style="width: 160px"
              placeholder="请选择品牌型号"
              :options="brandData"
              @change="handleChange"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="所属项目">
            <el-select
              size="small"
              filterable
              style="width: 160px"
              v-model="formInline.projectID"
              v-el-select-loadmore="loadMore"
              placeholder="请选择所属项目"
            >
              <el-option
                v-for="item in project.list"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="在线状态">
            <el-radio-group v-model="formInline.offlineStatus" size="small">
              <el-radio-button label="上线" border>上线</el-radio-button>
              <el-radio-button label="正常" border>正常</el-radio-button>
              <el-radio-button label="离线" border>离线</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </div>
        <div>
          <el-form-item>
            <el-button type="success" plain @click="onQuery">查询</el-button>
            <el-button plain @click="onReset">重置</el-button>
            <el-button type="success" plain @click="showMap = !showMap">
              地图定位</el-button
            >
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="btn-group" v-if="hasPermission('devicemanagement.pageadd')">
      <el-select
        size="small"
        filterable
        style="width: 160px"
        v-model="projectID"
        v-el-select-loadmore="loadMore"
        placeholder="请选择所属项目"
      >
        <el-option
          v-for="item in project.list"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-button type="success" plain @click="handleAdd">新增</el-button>
    </div>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column
        prop="No"
        label="序号"
        align="center"
        width="60"
        type="index"
      >
      </el-table-column>
      <el-table-column prop="SN" label="SN号" align="center" width="120">
      </el-table-column>

      <el-table-column prop="name" label="设备名称" align="center" width="200">
      </el-table-column>
      <el-table-column
        prop="offlineStatus"
        label="在线状态"
        align="center"
        width="80"
      >
        <template slot-scope="scope">
          <el-tag
            :type="
              scope.row.offlineStatus === '正常' ||
              scope.row.offlineStatus === '上线'
                ? 'success'
                : 'info'
            "
            disable-transitions
            >{{ scope.row.offlineStatus }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="brandName" label="品牌" align="center" width="120">
      </el-table-column>
      <el-table-column prop="modelName" label="型号" align="center" width="200">
      </el-table-column>
      <el-table-column
        prop="companyName"
        label="企业名称"
        align="center"
        width="120"
      >
      </el-table-column>
      <!-- <el-table-column
        prop="industryApplication"
        label="行业应用"
        align="center"
        width="120"
      >
      </el-table-column> -->
      <el-table-column
        prop="vehicleNumber"
        label="车辆编号"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <!-- 处理 null、undefined、空字符串等多种情况 -->
          <span
            v-if="scope.row.vehicleNumber && scope.row.vehicleNumber !== ''"
            class="vehicle-number-highlight"
          >
            {{ scope.row.vehicleNumber }}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        align="center"
        width="160"
      >
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="更新时间"
        align="center"
        width="160"
      >
      </el-table-column>

      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <!-- 默认显示的按钮 -->
          <el-button
            v-if="hasPermission('devicemanagement.History')"
            type="success"
            size="mini"
            plain
            @click="handleRealData(scope.$index, scope.row)"
            >实时数据</el-button
          >
          <el-button
            v-if="hasPermission('devicemanagement.History')"
            type="success"
            size="mini"
            plain
            @click="handleTrackData(scope.$index, scope.row)"
            >设备轨迹</el-button
          >

          <el-button
            v-if="hasPermission('devicemanagement.History')"
            type="primary"
            size="mini"
            plain
            @click="handleHistoryData(scope.$index, scope.row)"
            >历史数据</el-button
          >

          <!-- 更多按钮（下拉菜单） -->
          <el-dropdown
            :key="dropdownKey"
            @command="handleMoreCommand"
            trigger="click"
          >
            <el-button
              size="mini"
              plain
              type="primary"
              v-if="
                hasPermission('devicemanagement.lock') ||
                  hasPermission('devicemanagement.unlock') ||
                  hasPermission('devicemanagement.modify') ||
                  hasPermission('devicemanagement.delete')
              "
            >
              更多<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-if="hasPermission('devicemanagement.lock')"
                :command="{
                  action: 'lock',
                  index: scope.$index,
                  row: scope.row
                }"
                >锁车</el-dropdown-item
              >
              <el-dropdown-item
                v-if="hasPermission('devicemanagement.unlock')"
                :command="{
                  action: 'unlock',
                  index: scope.$index,
                  row: scope.row
                }"
                >解锁</el-dropdown-item
              >
              <el-dropdown-item
                v-if="hasPermission('devicemanagement.modify')"
                :command="{
                  action: 'edit',
                  index: scope.$index,
                  row: scope.row
                }"
                >修改</el-dropdown-item
              >
              <el-dropdown-item
                v-if="hasPermission('devicemanagement.delete')"
                :command="{
                  action: 'delete',
                  index: scope.$index,
                  row: scope.row
                }"
                divided
                style="color: #F56C6C;"
                >删除</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="formInline.pageNo"
        :page-sizes="[5, 10, 20, 30, 40]"
        :page-size="formInline.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="formInline.total"
      >
      </el-pagination>
    </div>
    <div v-show="showMap" class="map-container">
      <el-select
        size="small"
        filterable
        style="width: 160px"
        v-model="mapProjectID"
        v-el-select-loadmore="loadMore"
        placeholder="请选择所属项目"
      >
        <el-option
          v-for="item in project.list"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-button type="success" plain @click="handleMap"
        >设备位置查询</el-button
      >
      <div id="map" class="map-content"></div>
    </div>
  </div>
</template>

<script>
import { generateRandomString } from "@/utils/uuid";
export default {
  name: "deviceManagement",
  data() {
    return {
      projectID: "",
      mapProjectID: "",
      protocolData: [],
      brandData: [],
      project: {
        total: 0,
        list: [],
        pageNo: 1
      },
      tableData: [],
      formInline: {
        projectID: "",
        brandName: [],
        name: "",
        SN: "",
        pageNo: 1,
        pageSize: 10,
        total: 0,
        offlineStatus: ""
      },
      showMap: false,
      dropdownKey: 0,
      initialized: false, // 添加初始化标记
      command: {
        code: 201,
        msgId: "",
        msg: {
          cmd: "",
          state: null,
          heatTime: 0
        }
      }
    };
  },
  directives: {
    "el-select-loadmore": {
      bind(el, binding) {
        const scrollWrap = el.querySelector(".el-select-dropdown__wrap");
        scrollWrap.addEventListener("scroll", () => {
          const { scrollTop, scrollHeight, clientHeight } = scrollWrap;
          // console.log(
          //   `scrollTop: ${scrollTop}, scrollHeight: ${scrollHeight}, clientHeight: ${clientHeight}`
          // );

          if (Math.abs(scrollHeight - scrollTop - clientHeight) < 1) {
            binding.value(); // 触发加载更多
          }
        });
      }
    }
  },
  methods: {
    getProjects(pageNo) {
      const data = {
        pageNo: pageNo,
        pageSize: 10
      };
      this.$store.dispatch("device/handleRequest", {
        url: "/battery/dcProject/page",
        data: data,
        method: "GET",
        callback: response => {
          const filteredList = response.list.map(item => ({
            value: item.id,
            label: item.name
          }));
          this.project.list = [...this.project.list, ...filteredList];
          this.project.count = response.count;
        }
      });
    },
    loadMore() {
      if (this.project.list.length < this.project.count) {
        this.project.pageNo++;
        this.getProjects(this.project.pageNo);
        console.log("loadMore!");
      }
    },
    getBrandDataInfo() {
      // 获取品牌型号
      this.$store.dispatch("device/handleRequest", {
        url: "/battery/tree/brandModel",
        data: {},
        method: "GET",
        callback: response => {
          this.brandData = this.parseTreeDataWithParentId(response);
        }
      });
    },
    parseTreeDataWithParentId(nodes, parentId = "") {
      return nodes.map(node => {
        const newNode = {
          value: node.id,
          label: node.name,
          parentId: parentId
        };

        // 如果有 children 且不为空，才保留 children 字段
        if (node.children && node.children.length > 0) {
          newNode.children = this.parseTreeDataWithParentId(
            node.children,
            node.id
          );
        }

        return newNode;
      });
    },
    getDeviceList() {
      const data = {
        projectID: this.formInline.projectID,
        brandName: this.formInline.brandName.join(","),
        name: this.formInline.name,
        SN: this.formInline.SN,
        pageNo: this.formInline.pageNo,
        offlineStatus: this.formInline.offlineStatus,
        pageSize: this.formInline.pageSize
      };
      this.$store.dispatch("device/handleRequest", {
        url: "/battery/dcDevice/page2",
        data: data,
        method: "GET",
        callback: response => {
          this.tableData = response.list;
          this.formInline.total = response.count;
        }
      });
    },
    getProtocolData() {
      this.$store.dispatch("device/handleRequest", {
        url: "/battery/tree/protocol",
        method: "GET",
        callback: res => {
          this.protocolData = res.map(item => ({
            value: item.id, // 将 id 映射为 value
            label: item.name // 将 name 映射为 label
          }));
        }
      });
    },
    handleChange(value) {
      console.log(value);
      console.log(this.formInline.brandName);
    },
    handleMoreCommand(command) {
      const { action, index, row } = command;
      switch (action) {
        case "lock":
          this.handleLock(index, row);
          break;
        case "unlock":
          this.handleUnlock(index, row);
          break;
        case "edit":
          this.handleEdit(index, row);
          break;
        case "delete":
          this.handleDelete(index, row);
          break;
      }
    },
    handleDelete(index, row) {
      console.log(index, row);
      const data = {
        id: row.id
      };
      this.$confirm("确认删除该设备吗？") // 弹出确认框
        .then(() => {
          this.$store.dispatch("device/handleRequest", {
            url: "/battery/dcDevice/delete",
            data: data,
            method: "DELETE",
            callback: response => {
              this.$message.success("删除成功!");
              this.getDeviceList(); // 刷新列表
            }
          });
        })
        .catch(() => {});
    },
    onQuery() {
      this.getDeviceList();
    },
    handleAdd() {
      if (this.projectID === "") {
        this.$message.error("请选择所属项目!");
        return;
      }
      this.$router.push({
        path: "./addDevice",
        query: {
          brandData: this.brandData,
          protocol: this.protocolData,
          projectId: this.projectID
        }
      });
    },
    handleRealData(index, row) {
      console.log(index, row);
      // 仅指定设备进入通用实时数据页，其余设备仍走原 BMS 实时数据页
      if (row.SN === "KPT-31500001") {
        this.$router.push({
          path: "/realtimeQuery",
          query: { deviceSn: row.SN, deviceName: row.name }
        });
      } else {
        this.$router.push({
          path: "/realData",
          query: { data: row.id }
        });
      }
    },
    handleTrackData(index, row) {
      console.log(index, row);
      this.$router.push({
        path: "/deviceManagement/historyData",
        query: { data: row.id, active: "second" }
      });
    },
    handleHistoryData(index, row) {
      console.log(index, row);
      this.$router.push({
        path: "/deviceManagement/historyData",
        query: { data: row.id, active: "first" }
      });
    },
    handleLock(index, row) {
      console.log(index, row);
      this.command.msg.cmd = "deviceLock";
      this.command.msg.state = 1;
      this.command.msgId = `${generateRandomString()}|${new Date().getTime()}|${row.SN.replace(
        "KPT-",
        ""
      )}`;
      const data = {
        deviceID: row.id,
        command: this.command
      };
      this.$confirm("确认锁车吗？") // 弹出确认框
        .then(() => {
          this.$store.dispatch("device/handleRequest", {
            url: "/battery/operation/command",
            data: data,
            method: "POST",
            callback: response => {
              this.$message.success("锁车成功!");
              this.getDeviceList(); // 刷新列表
            }
          });
        })
        .catch(() => {});
    },
    handleUnlock(index, row) {
      console.log(index, row);
      this.command.msg.cmd = "deviceLock";
      this.command.msg.state = 0;
      this.command.msgId = `${generateRandomString()}|${new Date().getTime()}|${row.SN.replace(
        "KPT-",
        ""
      )}`;
      const data = {
        deviceID: row.id,
        command: this.command
      };
      this.$confirm("确认解锁吗？") // 弹出确认框
        .then(() => {
          this.$store.dispatch("device/handleRequest", {
            url: "/battery/operation/command",
            data: data,
            method: "POST",
            callback: response => {
              this.$message.success("解锁成功!");
              this.getDeviceList(); // 刷新列表
            }
          });
        })
        .catch(() => {});
    },
    handleEdit(index, row) {
      console.log(index, row);
      this.$router.push({
        path: "/deviceManagement/modifyDevice",
        query: {
          data: row,
          brandData: this.brandData,
          protocol: this.protocolData,
          projectId: row.projectID
        }
      });
    },
    handleCurrentChange(pageNo) {
      console.log("pageNo", pageNo);
      this.formInline.pageNo = pageNo;
      this.getDeviceList(); // 刷新列表
    },

    handleSizeChange(pageSize) {
      this.formInline.pageSize = pageSize;
      this.getDeviceList(); // 刷新列表
    },
    handleDownload(index, row) {
      console.log(index, row);
    },
    onReset() {
      this.formInline.projectID = "";
      this.formInline.brandName = [];
      this.formInline.name = "";
      this.formInline.SN = "";
      this.formInline.pageNo = 1;
      this.formInline.pageSize = 10;
      this.formInline.offlineStatus = "";
      this.getDeviceList(); // 刷新列表
    },
    handleMap() {
      this.$store.dispatch("device/handleRequest", {
        data: { projectID: this.mapProjectID },
        url: "/battery/dcDevice/projectGps",
        method: "GET",
        callback: response => {
          const devices = response.list.map(item => {
            return [item.sn, item.longitude, item.latitude, item.updateDate];
          });
          this.markLocations("map", devices);
        }
      });
      // 调用方式（支持混合地址字符串和经纬度数组）
      // this.markLocations("map", [
      //   [119.028732, 31.633061], // 经纬度数组
      //   [119.028732, 31.643061], // 经纬度数组
      //   [119.028732, 31.653061] // 经纬度数组
      // ]);
    },
    markLocations(mapId, locations) {
      AMap.plugin("AMap.Geocoder", () => {
        // 初始化地理编码器
        const geocoder = new AMap.Geocoder({
          city: "全国"
        });

        // 创建地图实例
        const map = new AMap.Map(mapId, {
          zoom: 13,
          center: [119.065096, 31.685456] // 默认中心点
        });

        // 存储所有标记点
        const markers = [];

        // 处理每个坐标点
        locations.forEach(location => {
          // 如果location是字符串地址（需要地理编码）
          if (typeof location === "string") {
            geocoder.getLocation(location, (status, result) => {
              if (status === "complete" && result.info === "OK") {
                const lnglat = [
                  result.geocodes[0].location.lng,
                  result.geocodes[0].location.lat
                ];
                this.addMarker(map, lnglat, "");
              }
            });
          }
          // 如果已经是经纬度数组
          else if (Array.isArray(location) && location.length === 4) {
            this.addMarker(map, location.slice(1, 3), location[0], location[3]);
          }
        });

        // 地图点击事件（可选保留）
        // map.on("click", e => {
        //   map.clearMap();
        //   const lnglat = [e.lnglat.getLng(), e.lnglat.getLat()];
        //   this.addMarker(map, lnglat, "");

        //   // 反向地理编码
        //   geocoder.getAddress(lnglat, (status, result) => {
        //     if (status === "complete" && result.info === "OK") {
        //       this.handleAddressResult(result, lnglat);
        //     }
        //   });
        // });
      });
    },

    // 添加标记点的辅助方法
    addMarker(map, lnglat, sn, time) {
      const marker = new AMap.Marker({
        position: lnglat,
        offset: new AMap.Pixel(-13, -30)
      });
      map.add(marker);
      map.setFitView();

      // 创建信息窗口（先显示经纬度）
      const infoWindow = new AMap.InfoWindow({
        offset: new AMap.Pixel(0, -30),
        content: `<div>加载地址中...</div>`
      });

      // 点击标记时获取详细地址
      marker.on("click", () => {
        // 显示加载中的信息窗口
        infoWindow.open(map, marker.getPosition());

        // 执行逆地理编码获取详细地址
        AMap.plugin("AMap.Geocoder", () => {
          const geocoder = new AMap.Geocoder({
            city: "全国"
          });

          geocoder.getAddress(lnglat, (status, result) => {
            if (status === "complete" && result.info === "OK") {
              const address = result.regeocode.formattedAddress || "未知地址";

              // 更新信息窗口内容
              infoWindow.setContent(`
            <div style="min-width: 150px">
              <div><b>设备SN：</b>${sn}</div>
              <div><b>更新时间：</b>${time}</div>
              <div><b>详细地址：</b>${address}</div>
              <div><b>经度：</b>${lnglat[0].toFixed(6)}</div>
              <div><b>纬度：</b>${lnglat[1].toFixed(6)}</div>
            </div>
          `);

              // 保存地址到组件数据（如果需要）
              // this.$set(this, "currentAddress", address);
              // this.$set(this.form, "lat", lnglat[1]);
              // this.$set(this.form, "lng", lnglat[0]);
            } else {
              console.error("地址查询失败，状态:", status, "结果:", result);

              // 根据具体错误类型显示不同信息
              let errorMsg = "地址查询失败";
              if (result && result.info) {
                errorMsg += `: ${result.info}`;
              }
              infoWindow.setContent(`
               <div style="min-width: 150px">
                <div><b>设备SN：</b>${sn}</div>
                <div><b>更新时间：</b>${time}</div>
                <div><b>错误信息：</b>${errorMsg}</div>
                <div><b>经度：</b>${lnglat[0].toFixed(6)}</div>
                <div><b>纬度：</b>${lnglat[1].toFixed(6)}</div>
              </div>
          `);
            }
          });
        });
      });

      return marker; // 返回marker以便后续操作
    },

    // 处理地址结果的辅助方法
    handleAddressResult(result, lnglat) {
      console.log("详细地址:", result.regeocode.formattedAddress);
      // this.newAddress = `${result.regeocode.formattedAddress}(${lnglat[0]},${lnglat[1]})`;
      // this.form.lat = lnglat[1];
      // this.form.lng = lnglat[0];
    },
    hasPermission(permission) {
      if (!permission) {
        return true;
      }
      let flag = false;
      const menus = this.$store.state.login.menu;
      for (let i = 0; i < menus.length; i++) {
        const menu = menus[i];
        if (menu == permission) {
          flag = true;
          break;
        }
      }
      return flag;
    },
    initializeData() {
      this.getProtocolData();
      this.getBrandDataInfo();
      this.getProjects(this.project.pageNo);
      this.getDeviceList();
      this.initialized = true;
    }
  },

  beforeMount() {
    console.log("beforeMount!");
    this.initializeData();
  }, //生命周期 - 挂载之前
  activated() {
    console.log("DeviceManagement  activated!");
    this.dropdownKey += 1; // 强制下拉菜单重新渲染
    // 当组件从缓存中恢复时，重新检查数据
    if (!this.initialized) {
      this.initializeData();
    }

    // 每次激活时都刷新设备列表
    this.getDeviceList();

    // 确保下拉菜单重新渲染
    this.$nextTick(() => {
      // 强制更新组件，解决 Element UI 下拉菜单的缓存问题
      this.$forceUpdate();
    });
  },
  deactivated() {
    console.log("DeviceManagement deactivated!");
  },
  created() {
    console.log("DeviceManagement created");
  }
};
</script>
<style lang="less" scoped>
.form-inline {
  border-bottom: 1px solid #dcdfe6;
}
.demo-form-inline {
  display: flex;
  justify-content: space-between;
  /deep/ .el-form-item {
    margin-bottom: 0;
  }
}
.btn-group {
  margin: 10px;
}
.pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  /deep/ .el-pagination {
    padding: 0;
  }
}
.map-container {
  // background-color: aquamarine;
  height: 600px;
  margin-top: 10px;
  margin-bottom: 20px;
}
.map-content {
  height: 90%;
  width: 90%;
  margin-top: 10px;
}
/* 车辆编号高亮样式 */
.vehicle-number-highlight {
  color: #1890ff; /* 亮蓝色 */
  font-weight: bold;
  /* 或者使用渐变色 */
  /* background: linear-gradient(135deg, #1890ff, #722ed1);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent; */
}

/* 如果需要更醒目的效果，可以添加背景 */
.vehicle-number-bg {
  background-color: #f0f9ff;
  padding: 4px 8px;
  border-radius: 4px;
  color: #096dd9;
  font-weight: 600;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/views/BMS/deviceManagement/deviceManagement.vue